import { Grid, Typography, debounce, Box } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setData, setServiceFunction } from "./../../../../store/formSlice";
import FormTextField from "./../../../../Controllers/Input";
import { debounceDuration, safeValue } from "../../siteMap/navigations/helpers";
import { canEditSelector } from "../../../../store/applicantsSlice";
import { proposalSelector } from "../../../../store/proposalSlice";
import { GetBioethicalApprovals } from "../../helpers/GifService/applicantService";
import { useLoading } from "../../../../providers/loadingProvider";

const pageName = "Bioethical certificates approvals";

const fields = {
  approved: "approved",
};

const EthicalApprovals = (props) => {
  const methods = useForm();
  const loading = useLoading();
  const dispatch = useDispatch();
  const { setValue, getValues, formState, watch } = methods;
  const [approval, setApproval] = useState({
    approved: null,
  });
  const canEdit = useSelector(canEditSelector);
  const proposal = useSelector(proposalSelector);
  const watchAll = watch();

  const watchersEntries = Object.keys(fields).map((k) => [
    fields[k],
    watch(`is${k}`),
  ]);
  const watchers = Object.fromEntries(watchersEntries);

  useEffect(() => {
    dispatch(setServiceFunction(`UpdateBioethicalApprovals`)); /////TODO - DONT KNOW YET WHAT FUNC IT WILL BE
  }, [dispatch]);

  useEffect(() => {
    const getApproval = async () => {
      const loadingId = loading.addLoading("Loading Approvals");
      const proposalId = proposal.id;
      const approval = await GetBioethicalApprovals({ proposalId });
      setApproval({ approved: approval });
      loading.removeLoading(loadingId);
    };
    if (proposal) getApproval();
  }, [proposal, loading]);

  // set form state in the store
  const debouncedSetData = useMemo(
    () =>
      debounce(() => {
        if (!approval) return;
        const dirty = Object.keys(formState.dirtyFields);
        const values = getValues(dirty);
        const fieldsToEmpty = Object.keys(watchers).filter(
          (key) => watchers[key] === false
        );
        if (dirty.length === 0 && fieldsToEmpty.length === 0) return;
        fieldsToEmpty.forEach((f) => {
          values[f] = "";
        });
        const approvalToUpdate = {
          ...values,
        };

        dispatch(
          setData({ approval: approvalToUpdate, proposalId: proposal.id })
        );
      }, debounceDuration),
    [
      dispatch,
      formState.dirtyFields,
      approval,
      getValues,
      watchers,
      proposal.id,
    ]
  );

  useEffect(() => {
    debouncedSetData();
  }, [debouncedSetData, watchAll]);

  useEffect(() => {
    if (!approval) return;
    const { approved } = approval;
    setValue(fields.approved, safeValue(approved));

    // look for the related bit fields and if there is a value in the textbox set them to true
    Object.keys(fields).forEach((key) => {
      setValue(`is${key}`, fields[key] != null);
    });
  }, [setValue, approval]);

  const Question = (label, name) => {
    return (
      <Box mb={3}>
        <Grid item xs={12}>
          <FormTextField
            multiline
            rowsmax={25}
            name={name}
            disabled={!canEdit}
          />
        </Grid>
      </Box>
    );
  };

  return (
    <FormProvider {...methods}>
      <form>
        <Grid container spacing={2}>
          <Grid item>
            <Typography variant="subtitle2">{pageName}</Typography>
          </Grid>
          <Grid item>
            <InfoOutlinedIcon color="primary" />
          </Grid>
          <Grid item xs={12}>
            {Question("Yes", fields.approved)}
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
};

export default EthicalApprovals;
